import React from "react"
import classes from "./hero.module.css"
import Image from "../../components/image"
import { Link } from "gatsby"

const Hero = () => (
  <div className={classes.Hero}>
    <div>
      <Image />
    </div>
    <div className={classes.HeroText}>
      <h1>Smart Skin Salon</h1>
      <Link to="https://bookings.gettimely.com/smartskin/bb/book">Book online</Link>
    </div>
  </div>
)

export default Hero

// <div style={{ maxWidth: `300px`, marginBottom: `1.45rem` }}>
// <Image />
// </div>
